import { render, staticRenderFns } from "./modalErrorDescComponent.vue?vue&type=template&id=e3d478dc"
import script from "./modalErrorDescComponent.vue?vue&type=script&lang=js"
export * from "./modalErrorDescComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports